import React from 'react'
import { pathOr } from 'ramda'
import { Alert } from 'reactstrap'
import styled from 'styled-components'
import VisibleOn from '../../common/components/VisibleOn'
import { Panel, Theme } from '@pga/pga-component-library'
import Title from './common/Title'
import JobApplySection from './JobApplySection'
import JobDetailInfoSection from './JobDetailInfoSection'
import JobDetailSideBar from './JobDetailSideBar'
import JobDetailStats from './JobDetailStats'
import { jobAdditionalData, isInternshipApplicantGroup, isValidDeadline, getFacilityUrl } from './utils'
import ShowApplyButton from './ShowApplyButton'
import ErrorOverlay from './ErrorOverlay'

const StyledPanel = styled(Panel)`
  box-shadow: none;
  max-width: 1150px;
  margin: 0px auto;
  @media (max-width: 1200px) {
    max-width: 1000px;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 992px) {
    max-width: unset;
    flex-direction: row;
  }
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  margin: 0px;
  padding: 0 10px 10px 10px;
`

export const ApplyForJob = styled.div`
  max-width: 700px;
  padding: 20px 30px 30px 0px;
  position: relative;
`

export const PageData = styled.div`
  padding-right: 30px;
`

export const DeadlineAlert = styled(Alert)`
  font-family: ${Theme.fonts.Montserrat};
  border-radius: 0;
  text-align: center;
`

export const DEADLINE_MESSAGE = 'The submission deadline for this job has expired.'

export default ({ data }) => {
  const isValidDeadlineDate = isValidDeadline(data.job)
  return (
    <StyledPanel>
      <ContentWrapper>
        <Content>
          { !isValidDeadlineDate
            ? <DeadlineAlert color='danger'>{DEADLINE_MESSAGE}</DeadlineAlert>
            : null
          }
          <Header>
            <Title>{isInternshipApplicantGroup(data) && 'Internship: ' }{pathOr('N/A', ['job', 'jobTitle'], data)}</Title>
            <VisibleOn width={991}>
              <ShowApplyButton data={data} facilityUrl={getFacilityUrl(data)} isValidDeadline={isValidDeadlineDate} />
            </VisibleOn>
          </Header>
          <JobDetailStats job={data.job} />
          <PageData>
            {jobAdditionalData(data.job).map(({ title, children }) => (
              <JobDetailInfoSection title={title} key={title} children={children} />
            ))}
          </PageData>
          <ApplyForJob>
            { !isValidDeadlineDate ? <ErrorOverlay message={DEADLINE_MESSAGE} /> : null }
            <JobApplySection data={data} facilityUrl={getFacilityUrl(data)} />
          </ApplyForJob>
        </Content>
        <JobDetailSideBar {...{ data }} />
      </ContentWrapper>
    </StyledPanel>
  )
}
